import { createFeature, createReducer, on } from '@ngrx/store';
import { Attribute, MetaData } from '@emi/shared/models';
import * as attributeActions from './attribute-actions';
import * as commonActions from '../common-actions';

export interface AttributeState {
    attributes: Attribute[];
    metadata: MetaData | null;
    searchText: string | null;
    loading: boolean;
    failed: boolean;
    error: string;
}

export const attributeFeatureKey = 'attributeFilters';

const initialState: AttributeState = {
    attributes: [],
    metadata: null,
    searchText: null,
    loading: false,
    failed: false,
    error: '',
};

export const attributeFeature = createFeature({
    name: attributeFeatureKey,
    reducer: createReducer(
        initialState,
        on(attributeActions.isLoadingAttributes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(attributeActions.getNextPageAttributes, (state) => {
            return {
                ...state,
                loading: true,
            };
        }),
        on(attributeActions.getAttributesSuccess, (state, { attributes, metadata, searchText }) => {
            return {
                ...state,
                attributes,
                metadata,
                searchText,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(attributeActions.updateAttributesSelectionSuccess, (state, { attributes, metadata }) => {
            return {
                ...state,
                attributes: [...state.attributes, ...attributes],
                metadata,
                loading: false,
                failed: false,
                error: '',
            };
        }),
        on(attributeActions.getAttributesFailure, (state, { error }) => {
            return {
                ...state,
                loading: false,
                failed: true,
                error: error.message,
            };
        }),
        on(attributeActions.searchAttributes, (state, { searchText }) => {
            return {
                ...state,
                loading: state.searchText !== searchText,
            };
        }),
        on(commonActions.clearFilters, () => {
            return initialState;
        })
    ),
});
